import React, { useEffect, useState } from "react";
import styles from "./PasswordModal.module.scss";
import validator from "../../../Util/validator";
import { FaRegEyeSlash } from "react-icons/fa6";
import Modal from "../../Common/Modal/Modal";
import { FaRegEye } from "react-icons/fa6";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  passwordProcessHandler: (password: string) => void;
}

function PasswordModal(props: Props) {
  const { isOpen, setIsOpen, passwordProcessHandler } = props;

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState<{
    password: string;
    confirmPassword: string;
  }>({
    password: "",
    confirmPassword: "",
  });

  const updatePasswordHandler = () => {
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "password",
        type: "password",
        value: password,
      },
      {
        key: "confirmPassword",
        type: "confirmPassword",
        value: confirmPassword,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      passwordProcessHandler(password);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setPassword("");
      setConfirmPassword("");
      setErrors({
        password: "",
        confirmPassword: "",
      });
    }
  }, [isOpen]);

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseIcon={false}>
        <div className={styles.mainContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Update Password</h1>
          </div>

          <div className={styles.mainBodyContainer}>
            <div className={styles.description}>
              Please update your password to continue
            </div>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Password</p>
              <div className={styles.passwordInputContainer}>
                <input
                  type={showPassword ? "text" : "password"}
                  className={styles.input}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className={styles.showPasswordButton}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FaRegEyeSlash className={styles.icon} />
                  ) : (
                    <FaRegEye className={styles.icon} />
                  )}
                </button>
              </div>
              <p className={styles.error}>{errors.password}</p>
            </div>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Confirm Password</p>
              <div className={styles.passwordInputContainer}>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className={styles.input}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  type="button"
                  className={styles.showPasswordButton}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <FaRegEyeSlash className={styles.icon} />
                  ) : (
                    <FaRegEye className={styles.icon} />
                  )}
                </button>
              </div>
              <p className={styles.error}>{errors.confirmPassword}</p>
            </div>
            <div className={styles.buttonContainer}>
              <button
                className={styles.cancelButton}
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </button>
              <button
                className={styles.updateButton}
                onClick={updatePasswordHandler}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default PasswordModal;
